import { useMemo } from 'react';
import { withNamespaces } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import MessageBox from 'src/modules/3rd-party-management/components/MessageBox';

import useSupplierOverviewCommunicationMentionSuggestions from './hooks/useSupplierOverviewCommunicationMentionSuggestions';

const CommunicationBoxes = ({
    t,
    supplierId,
    isOwnCompany = false,
}) => {
    const fetchMentionSuggestionsQuery = useSupplierOverviewCommunicationMentionSuggestions({
        supplierId,
        t,
    });

    const mentionSuggestionList = useMemo(() => {
        const data = fetchMentionSuggestionsQuery.data;

        if (!Array.isArray(data)) {
            return [];
        }

        return data.map((item) => ({
            text: item.full_name,
            url: item.id,
            value: item.full_name,
        }));
    }, [fetchMentionSuggestionsQuery.data]);

    return (
        <Row>
            <Col sm="12" md={!isOwnCompany ? '6' : '12'}>
                <MessageBox
                    settings={{
                        messageListUrl: '/supplier/comment/list_internal',
                        sendMessageUrl: '/supplier/comment/add_internal',
                        attachmentDownloadUrl: '/supplier/attachment/',
                        attachmentUploadUrl: '/supplier/attachment/upload',
                        attachmentDeleteUrl: '/supplier/attachment/',
                        supplierId,
                        headerOptions: {
                            displayFilters: false,
                            title: isOwnCompany ? 'Communication' : 'Internal Communication',
                        },
                        mention: {
                            enable: true,
                            suggestionList: mentionSuggestionList,
                        },
                    }}
                />
            </Col>

            {!isOwnCompany && (
                <Col sm="12" md="6">
                    <MessageBox
                        settings={{
                            messageListUrl: '/supplier/comment/list',
                            sendMessageUrl: '/supplier/comment/add',
                            attachmentDownloadUrl: '/supplier/attachment/',
                            attachmentUploadUrl: '/supplier/attachment/upload',
                            attachmentDeleteUrl: '/supplier/attachment/',
                            supplierId,
                            headerOptions: {
                                displayFilters: false,
                                title: 'External Communication',
                            },
                            mention: {
                                enable: false,
                            },
                        }}
                    />
                </Col>
            )}
        </Row>
    );
};

export default withNamespaces()(CommunicationBoxes);
